export default function AnimationControllBox({
  isRotateAni,
  setIsRotateAni,
  isAudio,
  setIsAudio,
  onReset,
}) {
  return (
    <div className="controllBox">
      <button
        onClick={() => setIsRotateAni(!isRotateAni)}
        title="애니메이션 재생/일시정지"
        className={isRotateAni ? "play" : "pause"}
      >
        애니메이션 재생/일시정지
      </button>
      <button
        className={isAudio ? "on" : "off"}
        onClick={() => setIsAudio(!isAudio)}
        title="오디오 재생/일시정지"
      >
        오디오 재생/일시정지
      </button>
      <button
        className="reset"
        onClick={() => onReset()}
        title="3D 모델을 원래 위치로 되돌립니다."
      >
        초기화
      </button>
    </div>
  );
}
